export default __webpack_public_path__ + "static/media/heating.2993f114.jpg";